import { apiClient } from "./client";

export type SmtpSecurity = "NONE" | "STARTTLS" | "SSL";

export type SmtpSettings = {
  smtp_enabled: boolean;
  smtp_host: string | null;
  smtp_port: number;
  smtp_security: SmtpSecurity;
  smtp_username: string | null;
  smtp_from: string | null;
  /** The password itself is never returned by the API. */
  smtp_password_set: boolean;
};

export type SmtpSettingsUpdate = {
  smtp_enabled: boolean;
  smtp_host: string | null;
  smtp_port: number;
  smtp_security: SmtpSecurity;
  smtp_username: string | null;
  smtp_from: string | null;
  /** Omit to keep the stored password; pass "" to clear it. */
  smtp_password?: string;
};

export type SmtpTestResult = {
  ok: boolean;
  detail: string | null;
};

export async function getSmtpSettings(): Promise<SmtpSettings> {
  const { data } = await apiClient.get<SmtpSettings>(
    "/api/v1/admin/platform-settings/smtp",
  );
  return data;
}

export async function updateSmtpSettings(
  p: SmtpSettingsUpdate,
): Promise<SmtpSettings> {
  const { data } = await apiClient.put<SmtpSettings>(
    "/api/v1/admin/platform-settings/smtp",
    p,
  );
  return data;
}

export async function testSmtpSettings(to: string): Promise<SmtpTestResult> {
  const { data } = await apiClient.post<SmtpTestResult>(
    "/api/v1/admin/platform-settings/smtp/test",
    { to },
  );
  return data;
}
